module.exports = __webpack_public_path__ + "img/main-filipiniana.0778289e.jpg";